import { api } from '@/api/api'
import { responseError } from '@/utilitários/handler/responseHandler'
import { useQuery } from '@tanstack/react-query'
import { AxiosError } from 'axios'

interface Categoria {
  id: string
  nome: string
  descricao: string
  createdAt: string
  updatedAt: string
  subcategorias: Array<{
    id: string
    nome: string
    descricao: string
  }>
}

interface CategoriasResponse {
  success: boolean
  message: string
  data: {
    items: Categoria[]
    total: number
    pagina: number
    limite: number
    paginas: number
  }
  status: number
}

export const usePremioCategoria = () => {
  const {
    data: categorias,
    error,
    status,
    isLoading,
    refetch,
  } = useQuery<Categoria[], AxiosError<any>>({
    queryKey: ['premio-categoria'],
    queryFn: endPoint,
    onError: (error) => responseError(error),
  })

  return { categorias, error, status, isLoading, refetch }
}

async function endPoint(): Promise<Categoria[]> {
  const result = await api().get('/premio-categoria', {
    params: {
      pagina: 1,
      limite: 10,
    },
  })
  return result.data.data.data.items
}
